{
  "admin": {
    "users": {
      "title": "Users",
      "subtitle": "Manage platform users, their permissions and associated DCRs.",
      "empty": "No users found.",
      "actions": {
        "new": "New User",
        "edit": "Edit",
        "resetPassword": "Reset password",
        "flush": "Refresh privileges"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by email or name…",
        "level": "Data access level",
        "status": "Status",
        "permission": "Permission",
        "dcr": "DCR",
        "all": "All",
        "onlineOnly": "Online only",
        "reset": "Reset filters"
      },
      "levels": {
        "global": "Global",
        "publisher": "User"
      },
      "status": {
        "active": "Active",
        "inactive": "Disabled"
      },
      "table": {
        "email": "Email",
        "name": "Name",
        "level": "Data access level",
        "status": "Status",
        "presence": "Presence"
      },
      "form": {
        "createTitle": "New User",
        "editTitle": "Edit User",
        "id": "ID",
        "name": "Name",
        "namePlaceholder": "Full name",
        "email": "Email",
        "emailPlaceholder": "email@example.com",
        "emailInvalid": "Invalid email",
        "password": "Password",
        "passwordPlaceholder": "Initial password",
        "passwordHint": "Minimum 6 characters.",
        "show": "Show",
        "hide": "Hide",
        "level": "Data access level",
        "sources": "Sources (DCR)",
        "sourcesHint": "Hold Ctrl/Cmd to select multiple DCRs.",
        "mainDcr": "Main DCR",
        "mainDcrPlaceholder": "Select the main DCR",
        "status": "Status",
        "permissions": "Permissions",
        "grantAll": "Grant all permissions",
        "copy": "Copy ID",
        "copied": "Copied!"
      },
      "messages": {
        "created": "User created.",
        "updated": "User updated."
      },
      "errors": {
        "load": "Unable to load users.",
        "create": "Failed to create user.",
        "update": "Failed to update user."
      },
      "presence": {
        "online": "Online",
        "offline": "Offline",
        "messages": {
          "flushed": "Privileges refresh sent to {{email}}.",
          "notOnline": "{{email}} is no longer online.",
          "autoFlushed": "Updated privileges propagated to {{email}} (online)."
        },
        "errors": {
          "flush": "Error while refreshing privileges."
        }
      },
      "resetPassword": {
        "title": "Reset Password",
        "user": "User",
        "email": {
          "title": "Send reset instructions by email",
          "hint": "An email with a link to reset the password is sent to the user. The link is valid for 24 hours.",
          "action": "Send email",
          "sending": "Sending…"
        },
        "direct": {
          "title": "Set a new password directly",
          "hint": "Immediately set a new password for this user. The user is not notified.",
          "placeholder": "New password",
          "action": "Set password",
          "saving": "Saving…",
          "tooShort": "Password is too short (minimum 6 characters)."
        },
        "messages": {
          "emailSent": "Reset instructions sent to {{email}}.",
          "passwordSet": "Password updated successfully."
        },
        "errors": {
          "email": "Could not send reset instructions.",
          "password": "Could not update the password."
        }
      }
    },
    "cmpCoreVersions": {
      "title": "CMP Core Versions",
      "subtitle": "Manage CMP core (cmp-core.js) versions and how many deployed configs use each one.",
      "empty": "No core versions found.",
      "current": "current",
      "actions": {
        "edit": "Edit"
      },
      "table": {
        "version": "Version",
        "releasedAt": "Released At",
        "configCount": "Configs using it",
        "notes": "Notes"
      },
      "edit": {
        "title": "Edit core version:",
        "releasedAt": "Released At",
        "notes": "Notes",
        "notesPlaceholder": "Release notes for this core version…"
      },
      "messages": {
        "updated": "Core version updated."
      },
      "errors": {
        "load": "Unable to load core versions.",
        "update": "Failed to update the core version."
      }
    },
    "visionConfigurator": {
      "title": "Vision Configurator",
      "subtitle": "Enable entities for Vision and map their P_* columns to audiences, personas and goals.",
      "empty": "No entities found.",
      "count": "{{count}} entities",
      "activated": "{{name}} activated for Vision.",
      "deactivated": "{{name}} deactivated for Vision.",
      "deactivateConfirm": "Deactivate Vision for \"{{name}}\"?\n\nThe entity will be removed from Vision and its entire column-mapping configuration will be permanently deleted. This cannot be undone.",
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name or DCR ID…"
      },
      "table": {
        "name": "Name",
        "dcrId": "DCR ID",
        "active": "Active in Vision"
      },
      "actions": {
        "configure": "Configure"
      },
      "errors": {
        "load": "Unable to load entities.",
        "toggle": "Could not update the entity state."
      },
      "mapping": {
        "title": "Column mapping",
        "add": "Add mapping",
        "addTitle": "Add column mapping",
        "editTitle": "Edit column mapping",
        "empty": "No column mappings yet.",
        "lockedCol": "Locked",
        "locked": "Locked",
        "unlocked": "Unlocked",
        "unlockedSession": "Unlocked (session)",
        "sessionUnlockHint": "Unlock to edit — temporary, not saved. The saved lock state is changed from the edit form.",
        "lockedEditHint": "Locked. Unlock this row first to edit it.",
        "lockedDeleteHint": "Locked. Unlock it for real (edit form → Locked off) before deleting.",
        "lockedFlagHint": "Persisted lock. When on, this row is protected from edits in the list until unlocked.",
        "column": "Column",
        "columnPlaceholder": "Select a P_* column",
        "columnRequired": "Select a column.",
        "objectType": "Object type",
        "object": "Object",
        "objectPlaceholder": "— select {{type}} —",
        "objectHint": "Grouped by owner. Selecting an object fills the display name automatically.",
        "objectName": "Object name",
        "objectId": "Object ID",
        "objectIdPlaceholder": "Object ID (optional)",
        "displayName": "Display name (in Vision)",
        "displayNamePlaceholder": "Name shown in Vision",
        "displayNameRequired": "Enter a display name.",
        "delete": "Delete",
        "deleteConfirm": "Delete mapping for {{column}} ({{object}})?",
        "created": "Column mapping added.",
        "updated": "Column mapping updated.",
        "deleted": "Column mapping deleted.",
        "loadError": "Failed to load mappings.",
        "saveError": "Save failed.",
        "deleteError": "Delete failed."
      }
    },
    "destinations": {
      "title": "Destinations",
      "subtitle": "Manage activation destinations: connectors, multi-DCR ownership and connection settings.",
      "empty": "No destinations found.",
      "count": "{{count}} destinations",
      "sandbox": "Sandbox",
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name, type, connector or owner…",
        "onlyChartSelected": "Only chart-selected ({{count}})",
        "onlyChartSelectedHint": "Show only the destinations selected in the chart above",
        "onlyChartSelectedEmpty": "Select destinations in the chart above to enable this filter"
      },
      "table": {
        "connectionStatus": "Connection status",
        "id": "ID",
        "name": "Name",
        "description": "Description",
        "type": "Type",
        "connector": "Connector",
        "owners": "DCRs",
        "owner": "Owner",
        "idType": "ID Type",
        "exportId": "Export ID",
        "status": "Status",
        "sandbox": "Sandbox",
        "actions": "Actions"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "conn": {
        "ok": "Connection OK",
        "error": "Connection failure",
        "pending": "Test connection for status update"
      },
      "actions": {
        "new": "New destination",
        "edit": "Modify connection",
        "test": "Test connection",
        "testing": "Testing…",
        "pushDetails": "File push details",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "delete": "Delete",
        "deleteConfirm": "Delete destination \"{{name}}\"? This cannot be undone."
      },
      "messages": {
        "created": "Destination created.",
        "updated": "Destination updated.",
        "deleted": "Destination \"{{name}}\" deleted.",
        "activated": "{{name}} activated.",
        "deactivated": "{{name}} deactivated.",
        "testOk": "Connection to {{name}} succeeded."
      },
      "errors": {
        "load": "Unable to load destinations.",
        "save": "Unable to save the destination.",
        "delete": "Unable to delete the destination.",
        "status": "Unable to update the destination status.",
        "test": "Connection test failed.",
        "typeRequired": "Select a destination type.",
        "ownerRequired": "Add at least one owner DCR."
      },
      "form": {
        "createTitle": "New destination",
        "editTitle": "Edit destination",
        "description": "Configure the connector, ownership and connection parameters.",
        "name": "Name",
        "namePlaceholder": "Destination name",
        "nameRequired": "Enter a name.",
        "type": "Destination type",
        "typePlaceholder": "Select a destination type",
        "connector": "Connector",
        "exportId": "Export ID type",
        "select": "Select…",
        "owner": "Owner (DCR)",
        "ownerPlaceholder": "Select the owner DCR",
        "visibility": "Visibility — other DCRs",
        "visibilityHint": "DCRs allowed to see/use this destination (besides the owner). Only a global-scope admin can change this.",
        "owners": "Owner DCRs",
        "ownerSelect": "Select a DCR…",
        "addOwner": "Add",
        "primaryOwner": "primary",
        "ownersHint": "The first DCR is the primary owner. Only a global-scope admin can change ownership.",
        "sandbox": "Sandbox destination",
        "connectionParams": "Connection parameters",
        "testConnection": "Test connection",
        "selectTypeFirst": "Select a destination type to configure its connection.",
        "paramsPreserved": "Existing connection parameters are kept. Enable editing to replace them.",
        "modifyParams": "Modify connection parameters",
        "keepExistingParams": "Keep existing parameters",
        "noParamsForConnector": "This connector has no editable parameters.",
        "showParams": "Show saved connection params",
        "savedParams": "Saved connection parameters",
        "showParamsError": "Unable to decrypt the saved connection params.",
        "create": "Create"
      },
      "pushDetails": {
        "title": "File push details",
        "date": "Date",
        "exportPath": "Export path",
        "destinationPath": "Destination path",
        "status": "Status",
        "description": "Description",
        "empty": "No push jobs for this day.",
        "error": "Unable to load push details."
      },
      "chart": {
        "title": "Push jobs",
        "subtitle": "Files uploaded, pending and in error per day",
        "range": "Range",
        "lastDays": "Last {{days}}d",
        "destinations": "Selected Destinations",
        "searchDestinations": "Search destinations…",
        "noDestinations": "No destinations",
        "clearSelection": "Clear selection",
        "onlyErrors": "Only errors",
        "showAll": "Show all",
        "noData": "No push jobs in this range.",
        "error": "Could not load push jobs.",
        "dayBreakdown": "Breakdown — {{date}}",
        "destination": "Destination",
        "series": {
          "uploaded": "Uploaded",
          "pending": "Pending",
          "error": "Errors"
        }
      }
    },
    "activations": {
      "title": "Activations",
      "subtitle": "Monitor audience activations and destination push jobs.",
      "empty": "No data.",
      "tabs": {
        "activations": "Activations",
        "jobs": "Jobs"
      },
      "toolbar": {
        "searchPlaceholder": "Search audience, destination, entity…",
        "count": "{{count}} activations",
        "includeInactive": "Include inactive/deleted destinations"
      },
      "filters": {
        "byActivationStatus": "By activation status",
        "byAudienceStatus": "By audience status"
      },
      "status": {
        "all": "All",
        "active": "Active",
        "stopped": "Stopped"
      },
      "audienceStatus": {
        "all": "All",
        "active": "Active",
        "stopped": "Stopped",
        "ended": "Ended",
        "draft": "Draft",
        "error": "Error"
      },
      "groupBy": {
        "label": "Group by",
        "destination": "Destination",
        "entity": "Entity",
        "audience": "Audience",
        "clear": "Clear grouping"
      },
      "table": {
        "destination": "Destination",
        "entity": "Entity",
        "audience": "Audience",
        "status": "Status",
        "volume": "Volume",
        "lastPush": "Last push",
        "externalSegmentId": "External segment ID"
      },
      "detail": {
        "audienceId": "Audience ID",
        "destinationId": "Destination ID",
        "entityId": "Entity ID",
        "audienceStatus": "Audience status",
        "notOperating": "not operating",
        "createdAt": "Created at",
        "updatedAt": "Updated at",
        "nextExecution": "Next execution",
        "startDate": "Start date",
        "endDate": "End date"
      },
      "statusMenu": {
        "title": "Change status",
        "setActive": "Set active",
        "setStopped": "Set stopped"
      },
      "messages": {
        "statusUpdated": "Activation status updated."
      },
      "errors": {
        "loadActivations": "Failed to load activations.",
        "statusUpdate": "Could not update activation status.",
        "loadJobs": "Failed to load jobs.",
        "loadJobDetails": "Failed to load job details."
      },
      "jobs": {
        "count": "{{count}} job summaries",
        "lastDays": "(last 7 days)",
        "allDestinations": "All destinations",
        "from": "From",
        "to": "to",
        "resetRange": "Reset to last 7 days",
        "uploadingCount": "{{count}} uploading",
        "errorsCount": "{{count}} errors",
        "noMatch": "No destinations match the filter.",
        "stats": {
          "uploaded": "Uploaded",
          "uploading": "Uploading",
          "queued": "Queued",
          "errors": "Errors"
        },
        "detailTable": {
          "description": "Description",
          "exportPath": "Export path",
          "destinationFile": "Destination file",
          "lastUpdate": "Last update"
        }
      }
    },
    "entities": {
      "title": "Entities",
      "subtitle": "Manage the platform's entities (DCRs / publishers).",
      "empty": "No entities found.",
      "actions": {
        "new": "New Entity",
        "edit": "Edit"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name or ID…"
      },
      "table": {
        "name": "Name",
        "status": "Status",
        "sandbox": "Sandbox"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "sandbox": {
        "yes": "Yes",
        "no": "No"
      },
      "form": {
        "createTitle": "New Entity",
        "editTitle": "Edit Entity",
        "id": "ID",
        "name": "Name",
        "namePlaceholder": "Entity name",
        "nameTaken": "Name already taken. Suggested:",
        "status": "Status",
        "sandbox": "Sandbox",
        "copy": "Copy ID",
        "copied": "Copied!"
      },
      "messages": {
        "created": "Entity created.",
        "updated": "Entity updated."
      },
      "errors": {
        "load": "Unable to load entities.",
        "create": "Failed to create entity.",
        "update": "Failed to update entity."
      }
    },
    "apiLog": {
      "title": "API Log",
      "subtitle": "API error log (read-only).",
      "empty": "No log entries found.",
      "actions": {
        "refresh": "Refresh"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by API, type or description…"
      },
      "table": {
        "time": "Time",
        "api": "API",
        "messageType": "Type",
        "messageDescription": "Description",
        "env": "Env"
      },
      "errors": {
        "load": "Unable to load the log."
      }
    },
    "overview": {
      "title": "Overview",
      "subtitle": "Cross-entity identity figures (global data scope only).",
      "filters": {
        "active": "Active filters",
        "tncidPlusOnly": "TNCID+ users only",
        "hasFirstVisit": "Tracked for more than 30 days",
        "hasEmail": "Has email",
        "hasMaid": "Has MAID",
        "hasIpLocation": "Has IP location",
        "hasCookieAdform": "Has Adform cookie",
        "hasCookieTtd": "Has TTD cookie",
        "hasCookieAudiencerate": "Has Audience Rate cookie",
        "hasZeotap": "Has Zeotap",
        "country": "Country",
        "gender": "Gender",
        "age": "Age range",
        "all": "All",
        "male": "Male",
        "female": "Female",
        "unknown": "Unknown"
      },
      "range": {
        "days": "{{count}} days"
      },
      "tabs": {
        "cards": "Cards",
        "table": "Table"
      },
      "table": {
        "section": "Section",
        "metric": "Metric",
        "tncids": "TNCIDs",
        "downloadCsv": "Download CSV"
      },
      "sections": {
        "identity": "Identity",
        "matchRates": "Match rates",
        "gender": "Gender",
        "age": "Age"
      },
      "metrics": {
        "total": "TNCIDs",
        "returning": "Tracked for more than 30 days",
        "italy": "Italy",
        "email": "Email",
        "maid": "MAID",
        "ipLandline": "IP landline",
        "adform": "Adform cookie",
        "ttd": "TTD cookie",
        "audRate": "Audience Rate cookie",
        "zeotap": "Zeotap cookie",
        "male": "Male",
        "female": "Female",
        "unknown": "Unknown",
        "age1824": "18-24",
        "age2534": "25-34",
        "age3544": "35-44",
        "age4554": "45-54",
        "age5564": "55-64",
        "age65p": "65+",
        "tncPlus": "TNCID+",
        "pctOfTotal": "% of TNCIDs",
        "pctOfTotalPlus": "% of TNCID+"
      },
      "errors": {
        "load": "Unable to load the overview.",
        "retry": "Retry"
      }
    },
    "dcrGroups": {
      "title": "Entity Groups",
      "subtitle": "Manage entity groups (DCRs/publishers) and their members.",
      "empty": "No groups found.",
      "allDcrs": "All entities",
      "noOwner": "No owner",
      "actions": {
        "new": "New Entity Group",
        "edit": "Edit"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name, type or owner…"
      },
      "table": {
        "name": "Name",
        "type": "Type",
        "owner": "Owner (Entity)",
        "members": "Members"
      },
      "types": {
        "audience": "Audience",
        "custom": "Custom List",
        "firstParty": "First Party"
      },
      "form": {
        "createTitle": "New Entity Group",
        "editTitle": "Edit Entity Group",
        "name": "Name",
        "namePlaceholder": "Group name",
        "type": "Type",
        "owner": "Owner (Entity)",
        "ownerPlaceholder": "Select the owner entity",
        "members": "Members (Entity)",
        "addMember": "Add Entity…",
        "add": "Add",
        "id": "ID",
        "status": "Status",
        "copy": "Copy ID",
        "copied": "Copied!"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "messages": {
        "created": "Group created.",
        "updated": "Group updated."
      },
      "errors": {
        "load": "Unable to load groups.",
        "create": "Failed to create group.",
        "update": "Failed to update group."
      }
    },
    "destinationTypes": {
      "title": "Destination Types",
      "subtitle": "For each destination type, configure the per-DCR service permissions and associated Export ID Types.",
      "empty": "No destination types found.",
      "allDcrs": "All DCRs",
      "actions": {
        "edit": "Edit"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name, description or connector…"
      },
      "table": {
        "name": "Name",
        "description": "Description",
        "connector": "Connector",
        "activationType": "Activation Type",
        "assisted": "Assisted Service",
        "self": "Self Service",
        "exportIds": "Export ID Types"
      },
      "form": {
        "title": "Edit Destination Type",
        "add": "Add",
        "addDcr": "Add DCR…",
        "addExportId": "Add Export ID Type…"
      },
      "messages": {
        "updated": "Destination type updated."
      },
      "errors": {
        "load": "Unable to load destination types.",
        "update": "Failed to update destination type."
      }
    },
    "providers": {
      "title": "Providers",
      "subtitle": "Manage data providers and their DCR association.",
      "empty": "No providers found.",
      "actions": {
        "new": "New Provider",
        "edit": "Edit"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name, site or DCR…",
        "status": "Status",
        "statusAll": "All"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "table": {
        "dcr": "DCR",
        "name": "Name",
        "site": "Site",
        "status": "Status"
      },
      "form": {
        "createTitle": "New Provider",
        "editTitle": "Edit Provider",
        "id": "ID",
        "name": "Name",
        "namePlaceholder": "Provider name",
        "site": "Site",
        "sitePlaceholder": "e.g. example.com",
        "publisher": "DCR (Publisher)",
        "publisherPlaceholder": "Select a DCR",
        "status": "Status",
        "usePublisherId": "Enable as website network (every ProviderID will be auto-generated)",
        "usePublisherIdHint": "The provider will adopt the selected DCR's ID (publisher = provider case). Only allowed if that ID isn't already used by another provider."
      },
      "messages": {
        "created": "Provider created.",
        "updated": "Provider updated."
      },
      "errors": {
        "load": "Unable to load providers.",
        "create": "Failed to create provider.",
        "update": "Failed to update provider.",
        "publisherIdTaken": "Cannot use this PublisherID: a provider with this ID already exists."
      }
    },
    "vendors": {
      "title": "Vendors",
      "subtitle": "Manage the vendors available for Export ID Types.",
      "empty": "No vendors found.",
      "actions": {
        "new": "New Vendor",
        "edit": "Edit"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name or ID…"
      },
      "table": {
        "name": "Name",
        "status": "Status"
      },
      "status": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "form": {
        "createTitle": "New Vendor",
        "editTitle": "Edit Vendor",
        "id": "ID",
        "name": "Name",
        "namePlaceholder": "Vendor name",
        "status": "Status"
      },
      "messages": {
        "created": "Vendor created.",
        "updated": "Vendor updated."
      },
      "errors": {
        "load": "Unable to load vendors.",
        "create": "Failed to create vendor.",
        "update": "Failed to update vendor."
      }
    },
    "exportIdTypes": {
      "title": "Export ID Types",
      "subtitle": "Manage export ID types and their vendor association.",
      "empty": "No Export ID Types found.",
      "actions": {
        "new": "New Export ID Type",
        "edit": "Edit"
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by name, type or vendor…"
      },
      "table": {
        "name": "Name",
        "exportIdType": "Export ID Type",
        "partyType": "Party Type",
        "vendor": "Vendor",
        "ttl": "TTL"
      },
      "form": {
        "createTitle": "New Export ID Type",
        "editTitle": "Edit Export ID Type",
        "name": "Name",
        "namePlaceholder": "Descriptive name",
        "exportIdType": "Export ID Type",
        "exportIdTypePlaceholder": "e.g. email_sha256",
        "exportIdTypeLocked": "The Export ID Type identifies the record and cannot be changed.",
        "identityLocked": "Name, Export ID Type and Party Type identify the record: when editing you can only change Vendor and TTL.",
        "partyType": "Party Type",
        "partyTypePlaceholder": "Select a party type",
        "vendor": "Vendor",
        "vendorNone": "None",
        "ttl": "TTL (optional)",
        "ttlPlaceholder": "Time to live"
      },
      "messages": {
        "created": "Export ID Type created.",
        "updated": "Export ID Type updated."
      },
      "errors": {
        "load": "Unable to load Export ID Types.",
        "create": "Failed to create Export ID Type.",
        "update": "Failed to update Export ID Type."
      }
    }
  },
  "notifyBroadcast": {
    "title": "Send notification",
    "subtitle": "Send a message to admins, a publisher, or a single user.",
    "target": "Recipient",
    "targets": {
      "admin": "Admins",
      "entity": "Publisher",
      "user": "User"
    },
    "selectPublisher": "Select publisher",
    "selectUser": "Select user",
    "searchPlaceholder": "Search…",
    "permAreas": {
      "analytics": "Analytics",
      "vision": "Vision",
      "reach": "Reach",
      "scripts": "Scripts",
      "cmp": "CMP",
      "admin_dashboard": "Admin dashboard",
      "special_features": "Special features"
    },
    "permFilter": {
      "title": "Filter by permission",
      "add": "Add permission filter…",
      "all": "All",
      "leaves": {
        "reach": {
          "audience": "Audience",
          "custom_import": "Custom import",
          "goal": "Goal",
          "reporting": "Reporting"
        },
        "special_features": {
          "can_impersonate": "Impersonate",
          "experiments": "Experiments",
          "can_broadcast": "Can broadcast"
        }
      }
    },
    "loading": "Loading…",
    "noResults": "No results",
    "messageType": "Type",
    "types": {
      "info": "Info",
      "success": "Success",
      "warning": "Warning",
      "error": "Error"
    },
    "message": "Message",
    "messagePlaceholder": "Write your message…",
    "alsoEmail": "Also send via email",
    "cancel": "Cancel",
    "send": "Send",
    "sending": "Sending…",
    "sent": "Notification sent",
    "failed": "Failed to send notification"
  },
  "experimentalFeatures": {
    "title": "Experimental features",
    "subtitle": "Enable features still in development. Only visible to admins.",
    "empty": "No experimental features available right now.",
    "menuLabel": "Experimental features",
    "markerTooltip": "Experimental feature",
    "features": {
      "audienceOwnerFilter": {
        "label": "Audience owner filter",
        "description": "Show the owner filter dropdown in the Reach audience list."
      },
      "audienceExtractionDateFilter": {
        "label": "Audience extraction date filter",
        "description": "Show a calendar in the Reach audience list to see the audiences extracted on a past day or scheduled for today and upcoming days (±31 days)."
      },
      "accordionProductsMenu": {
        "label": "Accordion products menu",
        "description": "Show the products menu as an accordion: each product expands to reveal its sub-menu, one at a time."
      },
      "audienceInsights": {
        "label": "Audience insights",
        "description": "Show the advanced audience insights: extractions/volumes/push charts and the Additional Info tabs (requires the admin dashboard permission)."
      }
    }
  },
  "sessionExpired": {
    "title": "Session expired",
    "message": "Your session has expired. Please log in again to continue.",
    "action": "Go to login",
    "updatedTitle": "Update applied",
    "updatedMessage": "The application has been updated and your session is no longer valid. Please log in again to continue."
  },
  "common": {
    "clearSearch": "Clear search",
    "loading": "Loading data...",
    "noData": "No data found",
    "table": "TABLE",
    "charts": "CHARTS",
    "showTableView": "Show table",
    "showChartsView": "Back to charts",
    "png": "PNG",
    "xls": "XLS",
    "help": "HELP",
    "retry": "Retry",
    "refresh": "Refresh",
    "allEntities": "All Entities",
    "cancel": "Cancel",
    "close": "Close",
    "show": "Show",
    "hide": "Hide",
    "copy": "Copy",
    "copied": "Copied!",
    "edit": "Edit",
    "save": "Save",
    "active": "Active",
    "inactive": "Inactive",
    "saving": "Saving…",
    "processing": "Processing...",
    "pagination": {
      "rowsPerPage": "Rows per page",
      "of": "of"
    },
    "page": "Page {{current}} of {{total}}",
    "rowsPerPage": "Rows per page",
    "entitySelectionWarning": "Select a specific entity to see this page's data — reports are per-entity.",
    "yes": "Yes",
    "no": "No"
  },
  "home": {
    "heroTitle": "With <span class=\"hero-highlight\">TNC Engine</span>, you can enrich your user insights, create audiences with AI support, and activate them directly — while maintaining full control of your data",
    "newsSubtitle": "Explore our latest news, interviews, and success stories on our website",
    "branded": {
      "title": "Discover TNC Engine news",
      "excerpt": "Articles, interviews and success stories about our data platform.",
      "cta": "Go to portfolio"
    },
    "readMore": "Read more",
    "article1": {
      "title": "How a media platform can maximise the value of audiences",
      "excerpt": "With Moreno Schioppa, Head of Trafficking at Piemme S.p.A., we analysed how media platforms can leverage audience data."
    },
    "article2": {
      "title": "How to make the most of better first-party data management",
      "excerpt": "One of the most complex challenges for structured brands: getting different technologies to talk to each other to maximise the value of first-party data."
    }
  },
  "destinations": {
    "title": "Destinations",
    "subtitle": "Configure activation endpoints and keep their credentials in sync.",
    "activation": {
      "title": "Activate Destination",
      "subtitle": "Select a destination to activate for this audience",
      "destinationsLabel": "Destinations",
      "destinationsHint": "Select one or more destinations to push this audience to.",
      "loadingDestinations": "Loading available destinations…",
      "noAvailableDestinations": "No destinations are configured for this channel.",
      "selectDestinationError": "Select at least one destination to continue.",
      "error": "Unable to activate the selected destinations.",
      "noDestinationsForType": "No destinations configured for this type.",
      "noTypes": "No destination types available.",
      "noDestinationsAvailable": "Request new destinations from the administrators",
      "requestHint": "Send a request to get help from an administrator.",
      "requestHintAssistedService": "Your request will be handled by an administrator.",
      "selectEntityForActivation": "This destination requires an entity. Select one to continue.",
      "selectEntityPlaceholder": "Select an entity",
      "requestButton": "Request Activation",
      "externalSegmentIdOptional": "External segment ID (optional)",
      "requestSent": "Activation request sent successfully.",
      "requestError": "Unable to send the activation request.",
      "editTitle": "Edit activation: {{name}}",
      "editSuccess": "Activation {{name}} updated",
      "editError": "Unable to update the activation.",
      "saveButton": "Save Changes",
      "noEditableFields": "This activation type has no editable fields.",
      "alerts": {
        "GAM": "Before activating the export, make sure at least 24 hours have passed since the segment was created on GAM."
      }
    },
    "fields": {
      "externalSegmentId": "External Segment ID",
      "pubmaticAudienceId": "Pubmatic Audience ID",
      "audienceName": "Audience Name",
      "description": "Description",
      "country": "Country",
      "price": "Price (CPM)",
      "externalSegmentParentId": "External Segment Parent ID",
      "externalSegmentParentIdDefault": "— Use destination default —",
      "refreshTaxonomy": "Refresh",
      "taxonomyLoading": "Loading TTD taxonomy…",
      "taxonomyEmpty": "No taxonomy nodes cached yet for this destination. Try Refresh.",
      "cpmRateAmount": "CPM Rate",
      "cpmCurrency": "CPM Currency",
      "percentOfMediaCost": "% of Media Cost",
      "rateLevel": "Rate Level",
      "partnerId": "Partner ID",
      "advertiserId": "Advertiser ID",
      "buyable": "Buyable",
      "activationNote": "Internal note",
      "excludeControlGroup": "Exclude control group (admin only)",
      "extendToFamily": "Extend to household (admin only)",
      "extendToFamilyNotApplied": "Not applied to {{names}}: it exports landline IPs, which match the household's home IP.",
      "extendToFamilyUnavailable": "Not available for destinations exporting landline IPs: they match the household's home IP.",
      "region": "Region",
      "segmentType": "Segment Type",
      "mergeMode": "Merge Mode",
      "trackingTagName": "Tracking Tag Name",
      "externalAudienceId": "External Audience ID",
      "entity": "Entity",
      "externalAudienceName": "External Audience Name",
      "ownerId": "Owner ID",
      "ttl": "TTL (days)",
      "segmentName": "Segment Name",
      "cpmPrice": "CPM Price",
      "countries": "Countries",
      "zeotapSegmentId": "Zeotap Segment ID",
      "zeotapDestinationId": "Zeotap Destination ID",
      "dataPrice": "Price",
      "currency": "Currency",
      "zeotapAccountType": "Send To",
      "accountName": "Account name",
      "accountId": "Account ID",
      "advertiserName": "Advertiser Name",
      "accountType": "Account",
      "accountTypePlaceholder": "Select account type",
      "companyId": "Company ID",
      "companyIdPlaceholder": "Find it in the Infosum interface or contact their support"
    },
    "activateButton": "Activate Destination",
    "gam": {
      "warning": "Before proceeding with the export, create the audience in Google Ad Manager. Proceed with the export only for audiences created in Google Ad Manager for at least 24 hours.",
      "audienceId": "Google Ad Manager Audience ID"
    },
    "tradeDesk": {
      "advertiserId": "Advertiser ID"
    },
    "dv360": {
      "accountType": "Google Display & Video 360 Account",
      "clientId": "Client ID",
      "accountTypePlaceholder": "Select account type",
      "accountTypes": {
        "advertiser": "DV360 Advertiser Account",
        "partner": "DV360 Partner Account"
      }
    },
    "adform": {
      "country": "Country",
      "accountName": "Account name",
      "countryPlaceholder": "Select country"
    },
    "pubmatic": {
      "accountType": "Account",
      "accountId": "Account ID",
      "accountTypePlaceholder": "Select account type",
      "accountTypes": {
        "publisher": "Publisher",
        "advertiser": "Advertiser"
      }
    },
    "actions": {
      "new": "+ Destination",
      "edit": "Edit",
      "delete": "Delete",
      "activate": "Activate",
      "deactivate": "Pause",
      "deleteConfirm": "Delete destination \"{{name}}\"?",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "close": "Close",
      "menuTitle": "Quick actions"
    },
    "filters": {
      "search": "Search destinations",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "selected": "Selected destinations",
      "selectedHint": "Choose one or more destinations to focus the list.",
      "searchPlaceholder": "Search destinations…",
      "noResults": "No destinations found"
    },
    "states": {
      "loading": "Loading destinations…",
      "empty": "No destinations available.",
      "saving": "Saving…"
    },
    "toolbar": {
      "total": "{{count}} destinations"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "table": {
      "connection": "Connection",
      "name": "Name",
      "type": "Type",
      "activation": "Activation",
      "owner": "Owner",
      "status": "Status",
      "active": "Active",
      "actions": "Actions"
    },
    "form": {
      "createTitle": "Create destination",
      "editTitle": "Edit destination",
      "description": "Fill in the basic metadata and provide the connector credentials.",
      "name": "Name",
      "destinationType": "Destination type",
      "select": "Select",
      "activation": "Activation: {{value}}",
      "connector": "Connector: {{value}}",
      "typeLabel": "Destination type",
      "activationLabel": "Activation type",
      "connectorLabel": "Connector type",
      "connectionParams": "Connection parameters (JSON)",
      "connectionHint": "Enter valid JSON with connection credentials",
      "connectionPlaceholder": "{\"JsonCredentials\": \"…\"}",
      "connectionFieldsHint": "Fill in the parameters required by the selected connector.",
      "uploadJson": "Upload credentials file",
      "selectTypeHint": "Select a destination type to configure the connection parameters.",
      "active": "Activate destination"
    },
    "messages": {
      "saved": "Destination saved successfully.",
      "deleted": "Destination deleted.",
      "activated": "Destination \"{{name}}\" activated.",
      "deactivated": "Destination \"{{name}}\" paused.",
      "loadError": "Unable to load destinations."
    },
    "errors": {
      "load": "Unable to load destinations.",
      "save": "Unable to save the destination.",
      "delete": "Unable to delete the destination.",
      "status": "Unable to update the destination status.",
      "typeRequired": "Select a destination type.",
      "invalidJson": "Connection parameters must be valid JSON.",
      "ownerRequired": "Select the destination owner before saving."
    },
    "pagination": {
      "rowsPerPage": "Rows per page",
      "page": "Page {{current}} of {{total}}"
    }
  },
  "sidebar": {
    "logoAlt": "The NewCo logo",
    "user": {
      "admin": "Admin",
      "standard": "User"
    },
    "userMenu": {
      "title": "User Menu"
    },
    "productSelector": {
      "title": "Product"
    },
    "dcr": {
      "select": "Select Entity",
      "searchPlaceholder": "Search Entity...",
      "empty": "No Entity found",
      "globalScope": "Global Data Scope",
      "title": "Entity"
    },
    "impersonate": {
      "myself": "— myself —",
      "title": "Impersonate user"
    },
    "changePassword": "Change password",
    "logout": "Logout",
    "documentation": "Documentation",
    "nav": {
      "public": "INSIGHTS",
      "personas": "PERSONAS",
      "audience": "AUDIENCES",
      "comparison": "AUDIENCE COMPARISON",
      "customImports": "IMPORTED DATA",
      "destinations": "DESTINATIONS",
      "goals": "CUSTOM RULES",
      "reporting": "REPORTING",
      "reportsProvider": "REVENUE (DATA PROVIDER)",
      "reportsConsumer": "COSTS (DATA CONSUMER)",
      "analyticsOverview": "OVERVIEW",
      "realtime": "REALTIME",
      "trackingScripts": "CONFIGURATIONS",
      "cmp": "CONFIGURATIONS",
      "config": "CONFIG",
      "exportIdTypes": "EXPORT ID TYPES",
      "vendors": "VENDORS",
      "providers": "PROVIDERS",
      "destinationTypes": "DESTINATION TYPES",
      "dcrGroups": "ENTITY GROUPS",
      "apiLog": "API LOG",
      "overview": "OVERVIEW",
      "entities": "ENTITIES",
      "users": "USERS",
      "cmpCoreVersions": "CMP CORE VERSIONS",
      "monitoring": "MONITORING",
      "operations": "OPERATIONS",
      "activations": "ACTIVATIONS",
      "goalsAdvanced": "CUSTOM RULES (ADVANCED)",
      "customImportsAdvanced": "IMPORTED DATA (ADVANCED)",
      "destinationsAdmin": "DESTINATIONS (ADMIN)",
      "visionConfigurator": "VISION CONFIGURATOR"
    },
    "filters": {
      "title": "Filters",
      "reset": "(reset)",
      "toggleTitle": "Apply filters to main charts",
      "toggleSubtitle": "Keep main charts aligned with current filters",
      "dateRanges": {
        "7days": "Last 7 days",
        "14days": "Last 14 days",
        "30days": "Last 30 days",
        "90days": "Last 90 days"
      },
      "device": {
        "label": "Device ({{selected}}/{{total}})"
      },
      "traffic": {
        "label": "Traffic Source ({{selected}}/{{total}})"
      },
      "audience": {
        "label": "Audience ({{selected}}/{{total}})",
        "summary": "Min: 2, Max: 5 audiences"
      },
      "goal": {
        "label": "Custom Rule",
        "none": "None"
      },
      "country": {
        "label": "Country",
        "searchPlaceholder": "Search country...",
        "noResults": "No countries found"
      },
      "multiSelection": "Multiple selection allowed",
      "singleSelection": "Single selection only"
    }
  },
  "changePassword": {
    "title": "Change password",
    "oldPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "cancel": "Cancel",
    "submit": "Update password",
    "loading": "Saving...",
    "success": "Password updated successfully.",
    "errors": {
      "allFieldsRequired": "Please fill in every field.",
      "passwordMismatch": "The confirmation password does not match.",
      "passwordTooShort": "The new password must be at least 8 characters long.",
      "wrongOldPassword": "The current password is not correct.",
      "samePassword": "Use a password that is different from the current one.",
      "generic": "Unable to update the password. Please try again later.",
      "encryption": "Unable to encrypt the password. Refresh the page and try again.",
      "unauthenticated": "Please log in again before changing your password."
    }
  },
  "dashboard": {
    "table": {
      "title": "Data Table",
      "columns": "Columns",
      "selectOption": "Select Option",
      "selectAll": "Select All",
      "headers": {
        "audiences": "AUDIENCES",
        "personas": "PERSONAS",
        "sources": "SOURCES",
        "device": "DEVICE",
        "goal": "CUSTOM RULE",
        "goalType": "CUSTOM RULES",
        "users": "USERS"
      },
      "options": {
        "source": "Source",
        "device": "Device",
        "goal": "Custom Rules"
      }
    },
    "deviceMetrics": {
      "device": "Device",
      "source": "Source",
      "goal": "Custom Rule"
    },
    "charts": {
      "totalUsers": "Total Users",
      "enrichedUsers": "Enriched Users",
      "usersByMetric": "Users by {{metric}}",
      "publicBreakdown": "Users by Insight Audiences",
      "personasBreakdown": "Users by Personas"
    },
    "tooltips": {
      "totalUsers": "Unique users counted in the selected date range.",
      "enrichedUsers": "Split between enriched and base users aggregated across all enabled data sources.",
      "usersByDevice": "Share of users by device/source/goal, based on the metric currently selected in the dropdown.",
      "publicBreakdown": "Trend of users over time broken down by selected audiences.",
      "personasBreakdown": "Trend of users over time broken down by selected personas."
    },
    "status": {
      "errorTitle": "Data unavailable",
      "errorDescription": "Dashboard data is not available right now.",
      "noData": "No data is available for the selected filters.",
      "noDataFilters": "No data is available for this combination of filters. Try adding or removing filters and retry."
    }
  },
  "publisherDashboard": {
    "title": "Analytics",
    "subtitle": "An overview of your audience activity and enrichment.",
    "timeRange": {
      "label": "Time range",
      "days": "{{count}} days"
    },
    "providerFilter": {
      "label": "Data provider",
      "all": "All data providers"
    },
    "stats": {
      "activeUsers": "Active users",
      "newUsers": "New users",
      "enrichedUsers": "Enriched users",
      "conversionEvents": "Conversion events by {{count}} users",
      "emails": "Users with emails",
      "maids": "Users with MAID"
    },
    "charts": {
      "trends": "TNCIDs trends",
      "goalSeries": "Goal",
      "missingData": "Data not yet available",
      "clusters": "Clusters",
      "exportIds": "TNCIDs with Third Parties/Other IDs sync"
    },
    "sections": {
      "geo": "Geo data",
      "ageGender": "Age and gender",
      "providerBreakdown": "Data provider details",
      "tags": "Tags"
    },
    "ageGender": {
      "total": "Total",
      "male": "Male",
      "female": "Female"
    },
    "technologies": {
      "browser": "Browsers",
      "device": "Devices",
      "os": "Operating systems",
      "other": "Other"
    },
    "actions": {
      "retry": "Retry"
    },
    "status": {
      "error": "Something went wrong while loading dashboard data.",
      "noData": "No data available for the selected time range."
    },
    "stale": {
      "label": "Data as of {{date}}",
      "tooltip": "Data not up to date: the latest available update is from {{date}}, not yesterday."
    }
  },
  "realtime": {
    "title": "Realtime",
    "subtitle": "Events received in the last minutes, updated live.",
    "subtitleGlobal": "Events received in the last minutes across all entities, updated live.",
    "window": {
      "label": "Time window",
      "minutes": "{{count}} min"
    },
    "live": {
      "pause": "Pause",
      "resume": "Resume live"
    },
    "updatedAt": "Updated at {{time}}",
    "sampling": {
      "title": "{{pct}}% sample of events",
      "detail": "The table shows {{shown}} of {{total}} events received."
    },
    "stats": {
      "total": "Events (last {{count}} min)",
      "lastMinute": "Events in the last full minute",
      "perSecond": "Events per second",
      "sampled": "Events in the list"
    },
    "dims": {
      "entity": "Entity",
      "provider": "Data provider",
      "sourceType": "Event"
    },
    "filters": {
      "label": "Filters:",
      "minute": "Minute",
      "clear": "Clear all"
    },
    "chart": {
      "title": "Events per minute",
      "total": "Total",
      "hint": "Click a bar to filter that minute; click a row on the right to drill down."
    },
    "breakdown": {
      "title": "By {{dim}}"
    },
    "table": {
      "title": "Events",
      "titleSampled": "Sampled events",
      "time": "Time",
      "email": "Email (SHA256)",
      "phone": "Phone (SHA256)",
      "customVars": "Custom var.",
      "customVarsHint": "{{count}} custom variables: open the event to see them",
      "empty": "No events for the selected filters.",
      "more": "Show more ({{shown}} of {{total}})",
      "truncated": "List truncated to the most recent events."
    },
    "detail": {
      "title": "Event detail",
      "loading": "Loading…",
      "error": "Unable to load the event.",
      "notFound": "Event not found.",
      "masked": "Identifiers are masked.",
      "unmasked": "Identifiers are shown in clear.",
      "identifiers": "Identifiers",
      "customVariables": "Custom variables",
      "fields": "All fields"
    },
    "labels": {
      "none": "(none)",
      "other": "Other"
    },
    "actions": {
      "retry": "Retry",
      "reveal": "Show in clear",
      "close": "Close"
    },
    "status": {
      "error": "Something went wrong while loading realtime data.",
      "forbidden": "You don't have permission to view realtime data for this scope.",
      "noData": "No events in the selected window."
    }
  },
  "personas": {
    "treemap": {
      "placeholder": "Audience {{index}}"
    }
  },
  "customImports": {
    "title": "Imported Data",
    "subtitle": "Manage datasets you import and monitor their processing status.",
    "actions": {
      "new": "+ Import Data",
      "create": "Create",
      "import": "Import",
      "edit": "Edit",
      "activate": "Activate",
      "deactivate": "Pause",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "close": "Close",
      "menuTitle": "Quick actions"
    },
    "filters": {
      "search": "Search imported data",
      "searchPlaceholder": "Search imported data…",
      "status": {
        "label": "Status",
        "active": "Active",
        "inactive": "Inactive"
      },
      "all": "All",
      "active": "Active",
      "inactive": "Paused"
    },
    "states": {
      "loading": "Loading imports…",
      "empty": "No imported data available."
    },
    "table": {
      "name": "Name",
      "exportIdType": "Export ID",
      "owner": "Owner",
      "createdAt": "Created",
      "exportIds": "Export IDs",
      "tncids": "Matched TNCIDs",
      "status": "Status",
      "actions": "Actions"
    },
    "form": {
      "createTitle": "Import Data",
      "editTitle": "Edit import",
      "description": "Upload a file to create a first-party audience or use it as a seed for a lookalike audience.",
      "name": "Name",
      "namePlaceholder": "Enter import name",
      "exportIdType": "ID type",
      "fileUpload": "Upload file",
      "fileUploadHint": "Upload a .csv or .xls file with a single column containing the IDs you want to import",
      "file": "File",
      "dropFileHint": "Drop the file here",
      "uploading": "Uploading… {{value}}%",
      "storagePath": "Ingestion folder",
      "storagePathHint": "Drop new files with the same format here to add them to this import automatically.",
      "ownerType": "Owner type",
      "ownerId": "Owner ID",
      "active": "Active",
      "status": "Activate immediately",
      "select": "Select an option",
      "selectIdTypeFirst": "Select an ID Type first"
    },
    "messages": {
      "saved": "Import saved successfully.",
      "activated": "Import activated.",
      "deactivated": "Import paused."
    },
    "errors": {
      "load": "Unable to load imports.",
      "save": "Unable to save this import.",
      "status": "Unable to update the status.",
      "fileRequired": "Please select a file to upload.",
      "preview": "Unable to preview file columns."
    },
    "pagination": {
      "rowsPerPage": "Rows per page",
      "page": "Page {{current}} of {{total}}"
    }
  },
  "goals": {
    "title": "Custom Rules",
    "subtitle": "Define custom rules to track user actions and conversions.",
    "actions": {
      "new": "+ Custom Rules",
      "edit": "Edit",
      "delete": "Delete",
      "activate": "Activate",
      "deactivate": "Pause",
      "extractionRunning": "Extraction in progress: this custom rule cannot be edited, recalculated or deleted until it finishes.",
      "recalculate": "Update",
      "downloadTrend": "Download trend data",
      "deleteConfirm": "Delete custom rule \"{{name}}\"?",
      "recalculateConfirm": "Recalculate custom rule \"{{name}}\" for the last 90 days?",
      "cancel": "Cancel",
      "save": "Save",
      "close": "Close",
      "menuTitle": "Quick actions",
      "processing": "Processing..."
    },
    "filters": {
      "search": "Search Custom Rules",
      "searchPlaceholder": "Search Custom Rules…",
      "status": {
        "label": "Status filter",
        "active": "Active",
        "inactive": "Paused"
      },
      "selected": "Selected Custom Rules",
      "selectedHint": "Choose one or more custom rules to filter the list.",
      "statusHint": "Filter by active or paused Custom Rules"
    },
    "states": {
      "loading": "Loading Custom Rules…",
      "empty": "No Custom Rules available.",
      "saving": "Saving…",
      "dataPending": "Waiting for data: it may take a few minutes after the extraction."
    },
    "table": {
      "description": "Name",
      "type": "Type",
      "owner": "Owner",
      "status": "Status",
      "events": "Events",
      "trend": "Events Trend"
    },
    "form": {
      "createTitle": "Create Custom Rule",
      "editTitle": "Edit Custom Rule",
      "description": "Create a rule to define a user segment for your audiences",
      "nameField": "Name",
      "namePlaceholder": "Enter Custom Rule name",
      "type": "Custom Rule type",
      "rule": "Custom Rule",
      "ruleHint": "Enter the matching pattern or condition",
      "isRegExp": "Use regular expression",
      "customVarName": "Variable name",
      "customVarValue": "Variable value",
      "customVarOperator": "Operator",
      "addValuePlaceholder": "Enter value...",
      "addRegExpPlaceholder": "Enter the regular expression...",
      "isNotEmptyHint": "Only checks that the variable has a non-empty value: no values needed.",
      "regexpHint": "The value is used as a regular expression, with no escaping, and matching is case-insensitive. The syntax is RE2, BigQuery's: lookahead, lookbehind and backreferences are not supported.",
      "compiledRuleLabel": "Rule that will be saved:",
      "literalMetacharsWarning": "The value contains regex characters that this operator treats as plain text (and therefore escapes). If you meant to write a regular expression, pick the \"Matches (RegExp)\" operator.",
      "addValue": "Add",
      "urlValue": "URL",
      "urlOperator": "Operator",
      "adsField": "Ads field",
      "adsOperator": "Operator",
      "adsValue": "Values",
      "adsIsNotEmptyHint": "Only checks that the field has a non-empty value: no values needed.",
      "entityType": "Owner type",
      "entityTypeHint": "e.g., Entity, Source, etc.",
      "entityId": "Owner ID",
      "showInDashboard": "Show in dashboard",
      "active": "Activate immediately",
      "select": "Select an option"
    },
    "messages": {
      "saved": "Custom rule saved successfully.",
      "deleted": "Custom rule deleted.",
      "activated": "Custom rule \"{{name}}\" activated.",
      "deactivated": "Custom rule \"{{name}}\" paused.",
      "recalculating": "Custom rule is being processed..."
    },
    "errors": {
      "load": "Unable to load custom rules.",
      "save": "Unable to save the custom rule.",
      "delete": "Unable to delete the custom rule.",
      "status": "Unable to update the custom rule status.",
      "noValues": "Please add at least one value.",
      "invalidRegExp": "Invalid regular expression: please check the syntax.",
      "re2Lookaround": "Lookahead and lookbehind ((?=, (?!, (?<=, (?<!) are not supported by BigQuery: rewrite the rule without them.",
      "re2Backreference": "Backreferences (\\1, \\k<name>) are not supported by BigQuery: rewrite the rule without them.",
      "re2AtomicGroup": "Atomic groups ((?>…) are not supported by BigQuery: use a regular group instead.",
      "recalculate": "Unable to recalculate the custom rule.",
      "missingSourceGroup": "Incomplete configuration: the selected entity does not have an associated first-party Source Group. Please contact an administrator."
    },
    "pagination": {
      "rowsPerPage": "Rows per page",
      "page": "Page {{current}} of {{total}}"
    },
    "warnings": {
      "extractionStalled": "Extraction started but never completed (nightly run included): try Recalculate."
    }
  },
  "confronto": {
    "title": "Personas & Insights Comparison",
    "sections": {
      "siteTraffic": "% SITE TRAFFIC",
      "siteTrafficSubtitle": "Site traffic share within the listed audiences",
      "italianTraffic": "% COUNTRY USERS IN LISTED AUDIENCES",
      "italianTrafficSubtitle": "Country traffic share within the listed audiences"
    },
    "empty": "No audiences selected.",
    "tooltip": {
      "type": "Type",
      "siteTraffic": "Site Traffic",
      "population": "Population Average",
      "types": {
        "personas": "Personas",
        "public": "Insights"
      }
    },
    "legend": {
      "public": "Insight Audiences",
      "personas": "Personas Audiences"
    },
    "controls": {
      "audienceLabel": "Filter",
      "allInsights": "All Insights",
      "allPersonas": "All Personas",
      "allAudiencesSelected": "All audiences",
      "oneSelected": "1 audience selected",
      "nSelected": "{{n}} audiences selected",
      "reset": "Reset",
      "searchLabel": "Search",
      "searchPlaceholder": "Search audience...",
      "limitLabel": "Show",
      "limitAll": "All",
      "limitSuffix": "audiences"
    },
    "noResults": "No audiences match your search."
  },
  "login": {
    "claim": "",
    "username": "Username",
    "password": "Password",
    "loginAs": "Login as username",
    "button": "Log In",
    "forgotPassword": "Forgot Password?",
    "errors": {
      "emptyEmail": "Email field can't be empty",
      "invalidCredentials": "Invalid username or password",
      "googleSignInFailed": "Google sign-in failed",
      "googleNotAuthorized": "This Google account isn't linked to any platform user. Contact your administrator to request access.",
      "googleUserInactive": "Your account is not active. Contact your administrator to reactivate it.",
      "googlePendingApproval": "Your account is awaiting approval.",
      "googleInvalidCredential": "Google sign-in failed. Please try again.",
      "pendingApproval": "Your account is awaiting approval."
    },
    "orDivider": "or"
  },
  "passwordRecovery": {
    "title": "Recover password",
    "description": "Enter your email address: we'll send you the instructions to reset your password.",
    "emailPlaceholder": "Email",
    "submit": "Send instructions",
    "submitting": "Sending…",
    "backToLogin": "Back to login",
    "messages": {
      "emailRequired": "Enter the email address associated with your account.",
      "recaptchaMissing": "Recaptcha has not been configured.",
      "success": "If the address is correct you'll receive an email with the instructions to reset your password.",
      "notFound": "No account associated with this email address was found.",
      "genericError": "Unable to start the password recovery process."
    },
    "errors": {
      "unavailableEnv": "Recaptcha is not available in this environment.",
      "unavailable": "Recaptcha is not available.",
      "token": "Unable to obtain the recaptcha verification token."
    }
  },
  "passwordReset": {
    "title": "Set a new password",
    "description": "Choose the new password for your account.",
    "passwordPlaceholder": "New password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "submit": "Set password",
    "submitting": "Saving...",
    "backToLogin": "Back to login",
    "messages": {
      "missingToken": "This link is not valid. Request a new password reset email.",
      "allFieldsRequired": "Please fill in every field.",
      "passwordMismatch": "The confirmation password does not match.",
      "passwordTooShort": "The new password must be at least 8 characters long.",
      "invalidToken": "This link has expired or has already been used. Request a new password reset email.",
      "success": "Password updated successfully. You'll be redirected to the login page.",
      "genericError": "Unable to set the new password. Please try again later."
    }
  },
  "footer": {
    "copyright": "Copyright ©️{{ year }} All rights reserved - The Newco S.r.l. - VAT 03670431208 - ",
    "links": {
      "products": "Products and Services Privacy Policy",
      "cookie": "Cookie Policy",
      "website": "Website Privacy Policy"
    }
  },
  "audiences": {
    "badge": {
      "unmanageable": "Unmanageable",
      "obsoleteFilters": "Obsolete filters"
    },
    "title": "Audiences",
    "subtitle": "Create and manage your audience",
    "table": {
      "status": "Status",
      "name": "Name",
      "volume": "Size"
    },
    "actions": {
      "create": "+ Create Audience",
      "preview": "Draft audience",
      "createDraft": "Create Draft",
      "save": "Save",
      "cancel": "Cancel",
      "resetSuggestedPoint": "Reset to Suggested",
      "showFullCurve": "Show full curve",
      "back": "Back to Audiences",
      "filter": "Filters",
      "resetFilters": "Reset filters",
      "menuTitle": "Quick actions",
      "edit": "Edit Audience",
      "clone": "Copy Audience",
      "statusUpdated": "Audience status updated",
      "statusUpdateFailed": "Unable to update the audience status",
      "processing": "Processing…",
      "exportStarted": "Audience generation in progress",
      "exportFailed": "Unable to start the process",
      "exportTimeout": "The extraction of \"{{name}}\" is taking longer than expected. Refresh the page to check the status.",
      "deleted": "Audience deleted",
      "deleteFailed": "Unable to delete the audience",
      "overlapLoaded": "Overlap data retrieved",
      "overlapFailed": "Unable to load overlap data",
      "pauseUpdate": "Pause update",
      "resumeUpdate": "Resume update",
      "export": "Export",
      "checkOverlap": "Check overlap",
      "delete": "Delete Audience",
      "deleteConfirm": "Delete the audience \"{{name}}\"?",
      "deleteConfirmTitle": "Delete audience",
      "deleteConfirmMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone",
      "exportConfirmTitle": "Export audience",
      "exportConfirmMessage": "Start a new export for \"{{name}}\"?",
      "confirmExport": "Start export",
      "pauseConfirmTitle": "Pause audience",
      "pauseConfirmMessage": "Do you want to pause the updates for \"{{name}}\"?",
      "pauseConfirmButton": "Pause",
      "resumeConfirmTitle": "Resume updates",
      "resumeConfirmMessage": "Do you want to resume updates for \"{{name}}\"?",
      "resumeConfirmButton": "Resume",
      "quick": {
        "edit": "Edit audience",
        "preview": "Draft audience",
        "approve": "Approve audience",
        "clone": "Copy audience",
        "pause": "Pause updates",
        "resume": "Resume updates",
        "activate": "Update now",
        "export": "Export audience",
        "overlap": "Compare audience",
        "delete": "Delete audience",
        "processing": "Processing…",
        "reportError": "Report to administrators"
      },
      "curvePendingWarning": "Quick actions will be available once the audience curve data is ready.",
      "incompatibleFiltersWarning": "This audience contains filters not supported by this interface. Incompatible filters will not be visible in the form and will be removed on save.",
      "obsoleteFiltersAlert": "This audience contains filters that are no longer supported (<strong>{{filters}}</strong>) and cannot be modified.",
      "customQueryInfo": "This audience uses a custom SQL query managed by an administrator. Filters cannot be edited from this interface.",
      "staleItemsWarning": "Some filter items are no longer available (shown in orange). Please review them before saving.",
      "close": "Close",
      "reportErrorSent": "Report sent to administrators",
      "reportErrorFailed": "Unable to send the error report"
    },
    "labels": {
      "unmanageable": "Unmanageable"
    },
    "filterTypes": {
      "__mixed__": "Mixed configuration (rules + interests)"
    },
    "toolbar": {
      "searchPlaceholder": "Search audience",
      "total": "{{count}} audiences"
    },
    "listFilters": {
      "status": {
        "title": "Filter by status",
        "active": "Active",
        "draft": "Draft",
        "paused": "Paused",
        "pending": "Pending",
        "error": "Error",
        "billable": "Billable"
      },
      "owner": {
        "title": "Filter by owner",
        "buttonDefault": "Owner",
        "searchPlaceholder": "Search owner",
        "empty": "No owner found",
        "clearSelection": "Clear selection",
        "sortLabel": "Sort by:",
        "sortByName": "Name",
        "sortByCount": "Audience count"
      },
      "extractionDate": {
        "title": "Filter by extraction date",
        "buttonDefault": "Extraction date",
        "clear": "Clear",
        "prevMonth": "Previous month",
        "nextMonth": "Next month",
        "hint": "Pick a day within the last 31 and the next 31.",
        "kindAll": "All",
        "kindDone": "Extracted",
        "kindPlanned": "To extract",
        "loading": "Loading…",
        "error": "Unable to load the extractions for this day.",
        "summaryPast": "{{done}} audiences extracted",
        "summaryToday": "{{done}} extracted · {{planned}} to extract",
        "summaryFuture": "{{planned}} audiences scheduled (estimated from the schedule)"
      }
    },
    "list": {
      "empty": "No audiences found with current filters.",
      "loading": "Loading audiences…",
      "error": "Unable to load audiences."
    },
    "details": {
      "meta": "Schedule: {{ schedule }}",
      "id": "ID",
      "copy": "Copy",
      "copySuccess": "Audience ID copied",
      "copyError": "Unable to copy the value",
      "createdBy": "Created by",
      "owner": "Owner",
      "volume": "Size",
      "createdAt": "Start",
      "endDate": "End",
      "lastExtraction": "Last update",
      "nextExtraction": "Next update",
      "schedule": "Schedule",
      "empty": "Select an audience to see the details",
      "accuracyPreview": "Accuracy Preview",
      "totalUsers": "Total Users",
      "processingData": "Volume calculation in progress. Reload the page in a few minutes to see the updated values."
    },
    "destinations": {
      "title": "Active exports",
      "activeTitle": "Active exports",
      "stoppedTitle": "Paused exports",
      "showStopped": "Show stopped ({{count}})",
      "hideStopped": "Hide stopped",
      "externalSegmentId": "External Segment ID",
      "copied": "Copied!",
      "externalIdCopied": "External Segment ID copied",
      "volume": "Size",
      "nextPush": "Next export",
      "lastPush": "Last export",
      "statusUnknown": "Pending",
      "availableTitle": "Activate export",
      "entity": "Owner",
      "connector": "Connector",
      "activate": "Activate",
      "activating": "Activating…",
      "activationSuccess": "Destination {{name}} activated",
      "activationError": "Unable to activate this destination",
      "activationUnavailable": "Destination cannot be activated automatically for this audience",
      "openModal": "Activate destination",
      "modalTitle": "Activate destination for \"{{name}}\"",
      "modalSubtitle": "Select a destination to export this audience.",
      "modalEmpty": "No destinations can be activated for this audience.",
      "searchPlaceholder": "Search destinations",
      "statusActive": "Active",
      "statusStopped": "Paused",
      "pause": "Pause export",
      "resume": "Resume export",
      "edit": "Edit activation",
      "empty": "No active destinations.",
      "menuTitle": "Activation actions",
      "forcePush": "Force push",
      "forcePushConfirmTitle": "Force push activation",
      "forcePushConfirmMessage": "This will immediately push \"{{audienceName}}\" to \"{{destinationName}}\", outside its normal schedule. Are you sure you want to continue?",
      "forcePushConfirmButton": "Force push",
      "forcePushSuccess": "Force push started for \"{{name}}\"",
      "forcePushError": "Unable to force push this activation",
      "stopConfirmTitle": "Pause activation",
      "stopConfirmMessage": "Do you also want to remove the audience from \"{{destinationName}}\"? If you choose \"Pause only\", the activation stays paused and can be resumed later. Removing it also deactivates the segment on the destination's side and cannot be resumed from here.",
      "stopOnlyButton": "Pause only",
      "stopAndRemoveButton": "Pause and remove",
      "removeSuccess": "Activation removed",
      "removeError": "Unable to remove this activation",
      "pushTrend": "Push trend",
      "pushTrendHint": "Push volumes over the last 14 days",
      "note": "Note"
    },
    "overlap": {
      "title": "Audience overlap",
      "source": "Source: {{ name }}",
      "target": "Compare to",
      "tncids": "TNCiD overlap",
      "sourceShare": "Source overlap",
      "targetShare": "Target overlap",
      "empty": "Run the \"Check overlap\" action to populate this list.",
      "loading": "Loading overlap data…",
      "searchPlaceholder": "Search audience or owner",
      "nameLabel": "Name",
      "owner": "Owner",
      "sortBy": "Sort by:",
      "resultsCount": "{{ count }} result(s)"
    },
    "pagination": {
      "rowsPerPage": "Rows per page",
      "page": "Page {{current}} of {{total}}"
    },
    "create": {
      "title": "Create audience",
      "subtitle": "Define targeting rules and other key configuration of your audience",
      "success": "Audience created successfully",
      "basic": "Audience details",
      "aiSection": "Targeting",
      "aiTip": "Create audiences describing users interests and behaviours",
      "tooltips": {
        "type": "Interests: Create audiences based on user characteristics such as interests, behaviors, and demographics.\nCustom Audience: Create audiences using your first-party data and user events.",
        "isPublic": "When enabled, the audience is visible and can be activated by other entities."
      },
      "types": {
        "interest": "Interests",
        "rule": "Custom Audience",
        "customquery": "Custom Query"
      },
      "actions": {
        "analysis": "Analyse prompt",
        "addTagTitle": "Add custom tag",
        "addTag": "Add tag",
        "removeTag": "Remove tag",
        "selectAllRegions": "Select all regions"
      },
      "previewSuccess": "Audience draft generated successfully",
      "previewError": "Unable to generate the audience draft.",
      "filters": {
        "title": "Refine with filters",
        "age": "Age",
        "ageAll": "All Ages",
        "ageUnknown": "Unknown",
        "gender": "Gender",
        "genderAll": "All Gender",
        "genderUnknown": "Unknown",
        "location": "Country",
        "locationAll": "All countries",
        "locationReset": "Reset country",
        "regionAll": "All Regions"
      },
      "similarUsers": {
        "sectionTitle": "Expansion",
        "label": "Expand audience with similar users",
        "yes": "Yes",
        "no": "No"
      },
      "expandVersion": {
        "label": "Expansion mode (admin)",
        "standard": "Standard",
        "weighted": "Weighted (IDF)",
        "curveUnavailable": "Curve not yet available for this mode: it will be calculated at the next extraction after saving."
      },
      "lookalikeMethod": {
        "label": "Lookalike method (admin)",
        "knn": "KNN (default)",
        "centered-knn": "Centered KNN",
        "centroid": "Centroid",
        "centered-centroid": "Centered centroid"
      },
      "rule": {
        "sectionTitle": "Targeting",
        "sectionSubtitle": "Combine first-party data with other audiences and create lookalikes.",
        "groupsTitle": "Rule group",
        "actions": {
          "custom_import": "Imported Data",
          "goal": "Custom Rule",
          "audience": "Audience",
          "source": "Source"
        },
        "groupName": "Group name",
        "groupNamePlaceholder": "e.g. High intent shoppers",
        "customField": "Selected values are combined using an OR condition.",
        "customPlaceholder": "Paste a file path or bucket reference",
        "selectCustomImport": "Select Imported Data",
        "goalField": "Custom Rule",
        "selectGoal": "Select Custom Rule",
        "audienceField": "Existing audience",
        "selectAudience": "Select an audience",
        "sourceField": "Source type",
        "selectSource": "Select a source",
        "searchPlaceholder": "Search…",
        "remove": "Remove",
        "removeBlock": "Remove rule group",
        "addBlock": "Add rule group",
        "groupOperator": "Group operator",
        "operator": {
          "and": "AND",
          "or": "OR",
          "not": "NOT",
          "and_not": "AND NOT"
        },
        "preview": {
          "title": "Rule preview",
          "block": "Rule Block {{index}}",
          "connector": "AND",
          "itemConnector": "OR",
          "empty": "Add at least one rule to visualize the preview."
        },
        "staleItemsWarning": "⚠ Unavailable items — remove them before saving:",
        "removeStaleItem": "Remove unavailable item"
      },
      "accuracy": {
        "high": "High",
        "medium": "Medium",
        "low": "Low",
        "description": {
          "high": "Maximum precision, limited audience size",
          "medium": "Balance between precision and size",
          "low": "Maximum reach, lower precision"
        }
      },
      "fields": {
        "type": "Audience type",
        "name": "Name",
        "description": "Description",
        "frequency": "Frequency",
        "startDate": "Next update",
        "endDate": "End update",
        "ongoing": "Update forever",
        "aiPrompt": "Brief",
        "useAllNetworkData": "Tag source",
        "accuracy": "Accuracy",
        "accuracyDescription": "Specify the exact number of users to include in the audience, or select the desired level of accuracy optimized by AI",
        "audienceSize": "Audience size",
        "audienceSizeHint": "Enter the exact number of users you want. Leave empty to use accuracy level.",
        "expandSimilar": "Expand audience with similar users",
        "region": "Region",
        "regionPlaceholder": "Select regions",
        "regionDisabled": "Select country first",
        "regionCount": "{{count}} Regions selected",
        "regionEmpty": "No region available",
        "isPublic": "Public audience"
      },
      "dataSources": {
        "network": "TNC Network",
        "firstParty": "First-party data",
        "networkOnly": "The data source for this audience will be the entire TNC network."
      },
      "scheduleTitle": "Schedule updates",
      "preview": {
        "accuracyDescription": "Review the incremental audience curve, choose the desired precision step, then confirm the schedule.",
        "selectedRange": "Distance range: {{range}}",
        "selectedUsers": "{{users}} users",
        "distanceRange": "Distance",
        "users": "users",
        "pendingGraphTitle": "The chart is not available yet",
        "pendingGraphMessage": "We already tried to recover the chart data, but it is still not ready. Please wait a couple of minutes and refresh the page to see the updated values.",
        "filtersChangedTitle": "The chart is no longer available",
        "filtersChangedMessage": "You changed the filters that determine the accuracy curve. The curve will be recalculated after saving. Restore the original filters to see the current chart again."
      },
      "placeholders": {
        "name": "New Audience",
        "description": "This audience contains",
        "aiPrompt": "Users that like football and shopping",
        "tag": "Custom tag",
        "location": "Search a country",
        "audienceSize": "e.g. 10000"
      },
      "summary": {
        "title": "Overview",
        "audienceType": "Audience type",
        "name": "Name",
        "startDate": "Next update",
        "frequency": "Frequency",
        "accuracy": "Accuracy",
        "volumes": "Volumes",
        "suggestedVolumes": "Suggested volumes",
        "notExtracted": "Not yet extracted",
        "age": "Age",
        "gender": "Gender",
        "location": "Location",
        "conditions": "Rule conditions",
        "conditionsEmpty": "Add rules to see the overview.",
        "previewPending": "Draft required"
      },
      "noInterestsConfirm": {
        "title": "Are you sure you want to create an audience without interest filters?",
        "confirm": "Yes",
        "cancel": "Cancel"
      },
      "leaveConfirm": {
        "title": "Are you sure you want to leave the audience creation?",
        "confirm": "Yes",
        "cancel": "Cancel"
      },
      "remoteChange": {
        "titleUpdated": "Audience modified",
        "bodyUpdated": "This audience has been modified by another user. Click Cancel to exit and view the updated version.",
        "titleDeleted": "Audience deleted",
        "bodyDeleted": "This audience has been deleted by another user. Click Cancel to exit."
      },
      "errorMissingPayload": "Missing required information to create the audience.",
      "errorGeneric": "Unable to create the audience, try later.",
      "errors": {
        "tagsRequired": "Please add at least one tag for Interest-based audience",
        "ruleFilterRequired": "Please add at least one filter (Audience, Custom Rule, Imported Data, or Source) for Custom audience",
        "interestFilterRequired": "Without interests, select at least a country or a gender.",
        "previewRequired": "Generate the audience draft before saving.",
        "missingFirstPartyGroup": "Incomplete configuration: the first-party data group for provider \"{{provider}}\" was not found. Please contact an administrator to complete the setup.",
        "missingGoalSourceGroup": "Incomplete configuration: goal \"{{goal}}\" does not have an associated Source Group. Please contact an administrator to complete the setup."
      }
    },
    "trend": {
      "noData": "No extraction data available.",
      "series": {
        "existing": "Existing",
        "new": "New",
        "removed": "Removed"
      }
    },
    "extractions": {
      "title": "Audience extractions",
      "subtitle": "Audiences extracted per day (last 31 days) and scheduled ahead",
      "advanced": "Advanced",
      "advancedHint": "Visible only with the admin dashboard permission",
      "error": "Could not load extractions.",
      "perDay": "/day",
      "peak": "peak",
      "scheduledDays": "days scheduled",
      "today": "today",
      "legendExtracted": "Extracted",
      "legendScheduled": "Scheduled",
      "experimental": "Experimental",
      "experimentalHint": "Experimental feature — enable it from the Experimental Features panel"
    },
    "volumes": {
      "title": "Volumes",
      "error": "Could not load volumes.",
      "empty": "No volume data yet.",
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "additionalInfo": {
      "title": "Additional info",
      "tabs": {
        "details": "Details",
        "volumes": "Volumes",
        "sociodemo": "Sociodemo",
        "tags": "Tags",
        "changelog": "Changelog"
      },
      "details": {
        "info": "Audience info",
        "status": "Status",
        "schedule": "Schedule",
        "volume": "Volume",
        "owner": "Owner",
        "description": "Description",
        "quality": "Quality index",
        "timerange": "Global timerange",
        "expand": "Expand similar users",
        "dates": "Dates",
        "created": "Created",
        "lastExtraction": "Last extraction",
        "nextExtraction": "Next extraction",
        "endDate": "End date",
        "id": "Audience ID",
        "copyId": "Copy ID",
        "copied": "Copied",
        "filters": "Filters",
        "tags": "Tags",
        "costs": {
          "title": "Cost Insights",
          "load": "Load Cost Insights",
          "loading": "Loading…",
          "error": "Could not load cost insights.",
          "lastExtraction": "Last Extraction",
          "avgExecution": "Avg Execution",
          "totalCost": "Total Cost"
        }
      },
      "sociodemo": {
        "error": "Could not load sociodemo.",
        "empty": "No sociodemo data available.",
        "male": "Male",
        "female": "Female",
        "total": "Total",
        "ageBreakdown": "Age breakdown",
        "noAges": "No age breakdown available."
      },
      "tags": {
        "error": "Could not load tags.",
        "empty": "No tag data available.",
        "targetSize": "Target size",
        "noTags": "No tags."
      },
      "changelog": {
        "error": "Could not load changelog.",
        "empty": "No changes recorded."
      }
    }
  },
  "validation": {
    "required": "This field is required",
    "invalid": "This field is invalid",
    "min": "Minimum value is {{ min }}",
    "max": "Maximum value is {{ max }}",
    "audienceQualityRequired": "Please select an accuracy level (High, Medium, Low) or specify an audience size"
  },
  "documentation": {
    "versionBanner": "<strong>TNC Engine version 0.8</strong> in development - Contact us for bugs and suggestions"
  },
  "errors": {
    "maintenance": "The platform is temporarily under maintenance. We apologize for the inconvenience.",
    "sandboxEntity": "Operation not available: this object belongs to a sandbox entity."
  },
  "trackingScripts": {
    "title": "Tracking Scripts",
    "subtitle": "Manage JS client-side configurations and deploy them per provider.",
    "actions": {
      "new": "New configuration",
      "edit": "Edit",
      "delete": "Delete",
      "deploy": "Deploy",
      "deploying": "Deploying...",
      "deleteConfirm": "Are you sure you want to delete \"{{name}}\"?",
      "deleteConfirmGcs": "Warning: deleting this configuration will permanently remove the following GCS files:\n\n{{files}}\n\nDo you want to continue?",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "activateConfirm": "Activating \"{{name}}\" will trigger an automatic deploy to apply the new configuration. Do you want to continue?",
      "deactivateConfirm": "Warning: deactivating \"{{name}}\" will trigger an automatic deploy and tracking on client sites will stop immediately. Do you want to continue?",
      "save": "Save",
      "cancel": "Cancel"
    },
    "fields": {
      "name": "Name",
      "publisherId": "Entity",
      "publisherIdPlaceholder": "Select an entity",
      "template": "Snippet template",
      "scripts": "Sync with third parties",
      "autostart": "Autostart",
      "tcf": "TCF",
      "publisher": "Publisher",
      "exclude": "Exclude",
      "fontsVersion": "Fonts version",
      "fontsVersionDefault": "default",
      "modules": "Modules",
      "callbackScript": "Callback script (JS)",
      "prepareScript": "Prepare script (JS)",
      "overwriteScript": "Overwrite (JS)",
      "snippetAppend": "Additional snippet code (JS)",
      "status": "Status",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "providers": "Associated providers"
    },
    "providers": {
      "alreadyInUse": "Already assigned to another configuration",
      "publisherAlreadyInUse": "The Publisher ID is already assigned to another configuration"
    },
    "filters": {
      "search": "Search",
      "searchPlaceholder": "Search by name...",
      "type": "Type"
    },
    "table": {
      "name": "Name",
      "publisherId": "Publisher ID",
      "scripts": "Scripts",
      "providers": "Providers",
      "status": "Status",
      "actions": "Actions"
    },
    "deploy": {
      "success": "Deploy completed for {{count}} providers",
      "partialError": "Deploy completed with {{errors}} errors",
      "error": "Error during deploy",
      "statusPending": "Pending deploy",
      "statusDeployed": "Deployed",
      "statusError": "Deploy error"
    },
    "purge": {
      "action": "Refresh CDN",
      "inProgress": "Refreshing CDN...",
      "success": "CDN cache invalidated for {{count}} paths",
      "partialError": "CDN cache invalidated with {{errors}} errors",
      "error": "Error during CDN refresh",
      "skipped": "CDN not configured (development environment)"
    },
    "messages": {
      "created": "Configuration created successfully",
      "updated": "Configuration updated successfully",
      "deleted": "Configuration deleted successfully",
      "statusUpdated": "Configuration activated and deploy completed",
      "statusDeactivated": "Configuration deactivated: tracking on client sites has been stopped",
      "newProviderWillBeCreated": "A new provider will be created for the selected ID",
      "confirmGcsDeleteWarning": "Warning: the following providers have been removed from the configuration and their GCS files will be permanently deleted:\n\n{{files}}\n\nDo you want to continue saving?"
    },
    "errors": {
      "load": "Error loading configurations",
      "save": "Error saving configuration",
      "delete": "Error deleting configuration",
      "deploy": "Error during deploy",
      "statusUpdate": "Error updating configuration status"
    },
    "empty": "No configurations found",
    "advanced": {
      "show": "Advanced settings",
      "hide": "Hide advanced settings"
    },
    "form": {
      "titleCreate": "New configuration",
      "titleEdit": "Edit configuration"
    },
    "snippet": {
      "title": "Integration script",
      "download": "Download",
      "copyClipboard": "Copy to clipboard",
      "copied": "Copied!",
      "viewConfigJs": "View config.js",
      "notDeployed": "config.js not yet deployed"
    }
  },
  "reports": {
    "title": "Report Configurations",
    "subtitle": "Manage custom report configurations for the selected entity.",
    "dashboardTitle": "Reports",
    "dashboardSubtitle": "Review earnings and spend summaries for the selected entity.",
    "provider": {
      "title": "Data Provider Report",
      "subtitle": "Earnings generated from audience sharing.",
      "summary": {
        "audienceTotal": "Actived audiences",
        "total": "TOTAL"
      }
    },
    "consumer": {
      "title": "Consumer Report",
      "subtitle": "Spend from audience usage.",
      "summary": {
        "audienceTotal": "Actived audiences",
        "draftTotal": "Executed drafts",
        "audienceIncluded": "included in plan",
        "draftIncluded": "included in plan",
        "total": "TOTAL"
      }
    },
    "actions": {
      "newConfig": "New configuration",
      "edit": "Edit",
      "delete": "Delete",
      "deleteConfirm": "Are you sure you want to delete \"{{name}}\"?",
      "deleteConfirmTitle": "Confirm deletion",
      "deleteConfirmMessage": "Are you sure you want to delete the configuration for \"{{name}}\"? This action cannot be undone.",
      "save": "Save",
      "cancel": "Cancel",
      "menuTitle": "Actions"
    },
    "filters": {
      "search": "Search",
      "searchPlaceholder": "Search by name...",
      "month": "Month",
      "monthOptions": {
        "all": "All months"
      },
      "year": "Year",
      "yearOptions": {
        "all": "All years"
      },
      "type": "Report type",
      "typeOptions": {
        "all": "All"
      }
    },
    "entity": {
      "summary": {
        "totalAmount": "Period total",
        "totalAmountHint": "Earnings for data providers and spend for consumers on the selected entity.",
        "quantity": "Reported quantity",
        "quantityHint": "Total reported quantity for the selected rows."
      },
      "table": {
        "date": "Date",
        "kind": "Direction",
        "details": "Details",
        "description": "Description",
        "quantity": "Quantity",
        "amount": "Amount"
      },
      "direction": {
        "earned": "Earnings",
        "spent": "Spend"
      },
      "metrics": {
        "entryType": "Entry type",
        "quantity": "Quantity",
        "counterparty": "Consumer entity"
      },
      "emptyPeriod": "No reports available for the selected period.",
      "empty": {
        "type": "No report rows available for {{type}}."
      }
    },
    "table": {
      "entity": "Entity",
      "details": "Configuration details",
      "createdAt": "Created",
      "updatedAt": "Updated"
    },
    "form": {
      "titleCreate": "New Report Configuration",
      "titleEdit": "Edit Report Configuration",
      "fields": {
        "type": "Type",
        "entity": "Entity",
        "status": "Status",
        "revenueShare": "Revenue Share",
        "planIncludedAudiences": "Included Audiences",
        "planIncludedDrafts": "Included Drafts",
        "pricePerAudience": "Price per Audience",
        "pricePerDraft": "Price per Draft"
      },
      "types": {
        "dataProvider": "Data Provider",
        "consumer": "Consumer"
      },
      "sections": {
        "dataProvider": "Data Provider Configuration",
        "consumer": "Consumer Configuration"
      },
      "validation": {
        "entityRequired": "A selected entity is required",
        "revenueShareInvalid": "Revenue share must be between 0 and 100",
        "planIncludedAudiencesRequired": "Included audiences must be >= 0",
        "planIncludedDraftsRequired": "Included drafts must be >= 0",
        "pricePerAudienceRequired": "Price per audience must be >= 0",
        "pricePerDraftRequired": "Price per draft must be >= 0"
      }
    },
    "messages": {
      "created": "Configuration created successfully",
      "updated": "Configuration updated successfully",
      "deleted": "Configuration deleted successfully",
      "customRowCreated": "Consumer custom row created successfully"
    },
    "errors": {
      "load": "Error loading configurations",
      "save": "Error saving configuration",
      "delete": "Error deleting configuration",
      "customRowSave": "Error saving consumer custom row",
      "customRowInvalid": "Fill in at least the consumer custom row date"
    },
    "consumerCustomRow": {
      "title": "Add custom row",
      "editTitle": "Edit custom row",
      "subtitle": "Insert a manual entry for the selected consumer.",
      "add": "Add custom row",
      "addButton": "Add row",
      "save": "Save",
      "fields": {
        "reportDate": "Report date",
        "entryAmount": "Quantity",
        "entryCost": "Amount",
        "entryDescription": "Description"
      }
    },
    "providerCustomRow": {
      "title": "Add custom row",
      "editTitle": "Edit custom row",
      "save": "Save",
      "fields": {
        "reportDate": "Report date",
        "earnings": "Amount",
        "entryDescription": "Description"
      }
    },
    "customRow": {
      "deleteConfirmTitle": "Confirm deletion",
      "deleteConfirmMessage": "Are you sure you want to delete the custom row \"{{name}}\"? This action cannot be undone."
    },
    "entryTypes": {
      "activation": "Activation",
      "audience": "Actived audiences",
      "custom": "Custom",
      "audience_included": "Audience included in plan",
      "audience_extra": "Audience extra",
      "draft_included": "Draft included in plan",
      "draft_extra": "Draft extra"
    },
    "empty": "No configurations found"
  },
  "cmp": {
    "title": "CMP",
    "subtitle": "Configure your Consent Management Platform (TCF 2.3) for each provider.",
    "actions": {
      "new": "New configuration",
      "edit": "Edit",
      "delete": "Delete",
      "deploy": "Deploy",
      "deploying": "Deploying...",
      "confirmDelete": "Delete configuration \"{{name}}\"?",
      "confirmDeleteGcs": "Warning: the following cmp.js files will be removed from the CDN:\n\n{{files}}\n\nConfirm deletion?"
    },
    "purge": {
      "action": "Refresh CDN",
      "inProgress": "Refreshing CDN...",
      "success": "CDN cache invalidated for {{count}} paths",
      "partialError": "CDN cache invalidated with {{errors}} errors",
      "error": "Error during CDN refresh",
      "skipped": "CDN not configured (development environment)"
    },
    "filters": {
      "search": "Search",
      "searchPlaceholder": "Search by name..."
    },
    "table": {
      "name": "Name",
      "language": "Language / GVL",
      "vendors": "Vendors",
      "providers": "Providers",
      "status": "Status"
    },
    "fields": {
      "statusActive": "Active",
      "statusInactive": "Inactive"
    },
    "form": {
      "titleCreate": "New CMP configuration",
      "titleEdit": "Edit CMP configuration",
      "name": "Name",
      "namePlaceholder": "e.g. Main CMP",
      "publisherId": "Entity",
      "publisherIdPlaceholder": "Select an entity",
      "consentLanguage": "Consent language",
      "publisherCC": "Publisher country code",
      "cmpId": "CMP ID (IAB)",
      "cmpVersion": "CMP version (IAB)",
      "cmpVersionHint": "Auto-derived from the major version of the selected core",
      "vendorListVersion": "GVL version",
      "privacyPolicyUrl": "Privacy Policy URL",
      "coreVersion": "CMP core version",
      "coreVersionCurrent": "up to date",
      "coreVersionOutdated": "v{{current}} is available — select it to update. A new deploy will be required.",
      "coreVersionMajorBump": "Breaking change: consider updating CmpVersion (IAB) to v{{major}} as well.",
      "autoShow": "Auto-show banner",
      "autoShowOn": "Yes — show banner on first visit",
      "autoShowOff": "No — do not show automatically",
      "purposes": "IAB Purposes (TCF 2.3)",
      "purposeLabel": "Purpose",
      "legalBasisConsent": "Legal basis: Consent",
      "legalBasisLI": "Legal basis: Legitimate Interest",
      "vendors": "Vendors",
      "vendorsSelected": "selected",
      "vendorSearchPlaceholder": "Search vendor by name or ID...",
      "vendorNoResults": "No vendors found",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "allVendorsSelected": "All vendors selected",
      "status": "Status",
      "providers": "Providers",
      "publisherProvider": "Publisher (this entity)",
      "noProviders": "No providers available",
      "removeDeployedProviderConfirm": "Provider \"{{id}}\" already has a deployed cmp.js. Removing it from this configuration means the file will no longer be updated on the next deploy. Continue?",
      "advanced": "Advanced settings",
      "cookieName": "Cookie name",
      "cookieExpireDays": "Cookie expiry (days)",
      "i18n": "UI text overrides (i18n)",
      "onConsentSaved": "onConsentSaved callback"
    },
    "notifications": {
      "created": "CMP configuration created successfully",
      "updated": "CMP configuration updated successfully",
      "deleted": "CMP configuration deleted successfully",
      "deployed": "Deploy completed for {{count}} providers",
      "deployPartial": "Deploy completed: {{ok}} OK, {{err}} errors"
    },
    "errors": {
      "loadFailed": "Error loading configurations",
      "saveFailed": "Error saving configuration",
      "deleteFailed": "Error deleting configuration",
      "deployFailed": "Error during deploy"
    },
    "empty": "No CMP configurations found",
    "outdated": {
      "tooltip": "CMP version outdated — a new deploy is recommended"
    },
    "snippet": {
      "title": "CMP Implementation Snippet",
      "hint": "Paste this <script> tag in the <head> of the client's site, before other tracking scripts.",
      "badgeTooltip": "Click to view implementation snippet",
      "viewCmpJs": "View cmp.js",
      "notDeployed": "cmp.js not yet deployed — run deploy first",
      "download": "Download snippet",
      "copyClipboard": "Copy to clipboard",
      "copied": "Copied!"
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread": "unread",
    "empty": "No notifications yet",
    "markAsRead": "Mark as read",
    "seeAll": "See all notifications",
    "newNotification": "New notification",
    "pageSubtitle": "Your notification history.",
    "scopeNotice": "You're seeing only your personal notifications and those of the currently selected entity.",
    "tabs": {
      "personal": "Personal notifications",
      "admin": "Admin notifications",
      "entity": "Current entity notifications",
      "entityAll": "All entity notifications"
    },
    "searchPlaceholder": "Search notifications…",
    "noResults": "No notifications match your filters",
    "loading": "Loading…",
    "loadingMore": "Loading more…",
    "markAllAsRead": "Mark all as read",
    "markAsUnread": "Mark as unread",
    "markSelectedAsRead": "Mark as read",
    "markSelectedAsUnread": "Mark as unread",
    "selectAll": "Select all",
    "selectedCount": "{{count}} selected",
    "clearSelection": "Clear",
    "selectRow": "Select notification",
    "readFilters": {
      "all": "All",
      "unread": "Unread",
      "read": "Read"
    },
    "filters": {
      "all": "All",
      "info": "Info",
      "success": "Success",
      "warning": "Warning",
      "error": "Error"
    }
  },
  "visionConfig": {
    "title": "Vision Config",
    "subtitle": "Manage publisher access to Vision and configure column mappings.",
    "tabs": {
      "publishers": "Publishers",
      "mapping": "Column Mapping"
    },
    "filters": {
      "searchPlaceholder": "Search publishers…"
    },
    "publishers": "publishers",
    "errors": {
      "loadFailed": "Error loading data"
    },
    "table": {
      "publisher": "Publisher",
      "dcrId": "DCR ID",
      "status": "Status",
      "visionAccess": "Vision Access",
      "columnName": "Column",
      "objectType": "Type",
      "objectName": "Object Name",
      "objectId": "Object ID"
    },
    "actions": {
      "configureMapping": "Configure Mapping",
      "newMapping": "New Mapping"
    },
    "mapping": {
      "selectHint": "Select a publisher from the Publishers tab to manage its column mappings.",
      "empty": "No mappings configured yet for this publisher."
    },
    "form": {
      "titleNewMapping": "New Column Mapping",
      "titleEditMapping": "Edit Column Mapping",
      "columnName": "Column name",
      "objectType": "Object type",
      "objectId": "Object",
      "objectIdSelect": "— select —",
      "objectIdPlaceholder": "optional ID",
      "objectName": "Object name",
      "objectNamePlaceholder": "Display name"
    }
  },
  "visionConfigurator": {
    "title": "Vision Configurator",
    "subtitle": "Create and configure DCR instances: column mappings, custom variables and users.",
    "tabs": {
      "instances": "DCR Instances",
      "configurator": "Configurator"
    },
    "configTabs": {
      "mapping": "Column Mapping",
      "variables": "Custom Variables",
      "users": "Users"
    },
    "configurator": {
      "selectHint": "Select a DCR instance from the Instances tab to open the configurator."
    },
    "instances": {
      "search": "Search instances…",
      "createNew": "New DCR",
      "empty": "No DCR instances found. Create the first one.",
      "table": {
        "id": "#",
        "name": "Name"
      },
      "actions": {
        "configure": "Configure",
        "delete": "Delete"
      },
      "errors": {
        "loadFailed": "Error loading DCR instances",
        "createFailed": "Error creating DCR instance",
        "deleteFailed": "Error deleting DCR instance"
      },
      "form": {
        "title": "New DCR Instance",
        "name": "Name",
        "namePlaceholder": "e.g. My Publisher Vision",
        "note": "A unique UUID will be automatically generated for this DCR. The dynamic data tables (raw_data, agg_data, column_mapping) will be created on the backend."
      }
    },
    "variables": {
      "empty": "No custom variables defined for this DCR.",
      "actions": {
        "new": "New Variable"
      },
      "errors": {
        "loadFailed": "Error loading custom variables"
      },
      "table": {
        "name": "Name",
        "type": "Type",
        "value": "Value"
      },
      "form": {
        "titleNew": "New Custom Variable",
        "titleEdit": "Edit Custom Variable",
        "name": "Variable name",
        "type": "Type",
        "value": "Value"
      }
    },
    "users": {
      "empty": "No users configured for this DCR.",
      "searchPlaceholder": "Search users…",
      "actions": {
        "new": "New User"
      },
      "errors": {
        "loadFailed": "Error loading users"
      },
      "roles": {
        "admin": "Admin",
        "user": "User"
      },
      "table": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "status": "Status"
      },
      "form": {
        "titleNew": "New User",
        "titleEdit": "Edit User",
        "name": "Full name",
        "email": "Email",
        "password": "Password",
        "status": "Status",
        "isAdmin": "Administrator"
      }
    }
  },
  "versionUpdate": {
    "message": "A new version of the app is available.",
    "reload": "Reload"
  }
}
